import React from 'react'
import {NavLink} from 'react-router-dom';
import {withRouter} from 'react-router-dom';
import uuidv1 from 'uuid/v1';
import PropTypes from 'prop-types';

const breadcrumbs = (props) => {

    const path = props.location.pathname.split('/').filter((item) => item.length > 0);

    if (path.length === 0) { // Homepage
        return (
                <ul className="unstyled-list breadcrumbs">
                    <li className="breadcrumbs__item breadcrumbs__item--active" key={uuidv1()}>
                        <span className="breadcrumbs__link">Home</span>
                    </li>
                </ul>
        )
    }

    const renderBreadcrumbItemsForDesktop = () => {

        let breadcrumbsJSX = path.map((breadcrumb, index, breadcrumbs) => {
            // Check if it's not a last element
            if (index !== breadcrumbs.length - 1) {

                const currentBreadcrumbIndex = breadcrumbs.findIndex((item) => {
                    return item === breadcrumb
                }) + 1;
                const breadcrumbPath = breadcrumbs.slice(0, currentBreadcrumbIndex).join('/');

                if (props.searchPath) {
                    return (
                            <li className="breadcrumbs__item" key={uuidv1()}>
                                <NavLink
                                        to={{
                                            pathname: '/' + breadcrumbPath,
                                            search: props.searchPath
                                        }}
                                        className="breadcrumbs__link">
                                    {getPageTitle(breadcrumb)}
                                </NavLink>
                            </li>
                    )
                } else {
                    return (
                            <li className="breadcrumbs__item" key={uuidv1()}>
                                <NavLink
                                        to={'/' + breadcrumbPath}
                                        className="breadcrumbs__link">
                                    {getPageTitle(breadcrumb)}
                                </NavLink>
                            </li>
                    )
                }
            } else {
                // Grey out last element
                return (
                        <li className="breadcrumbs__item breadcrumbs__item--active" key={uuidv1()}>
            <span className="breadcrumbs__link">
                {props.pageTitle ? getPageTitle(props.pageTitle) : getPageTitle(breadcrumb)}
            </span>
                        </li>
                )
            }
        });

        // Artificially add home page in the beginning
        breadcrumbsJSX.unshift(
                <li className="breadcrumbs__item" key={uuidv1()}>
                    <NavLink to="/" className="breadcrumbs__link">Home</NavLink>
                </li>
        );

        return breadcrumbsJSX;
    };

    const getPageTitle = (pageTitle) => {
        let regex = /(?!a\b|or\b|to\b)\b([a-zA-Z])([a-zA-Z]+)/g;
        pageTitle = pageTitle.replace("-and-", "-&-");
        return pageTitle.replace(regex, (_, g1, g2) => g1.toUpperCase() + g2.toLowerCase()).replace(/-/g, ' ');
    };

    const getPreviousRouteForMobile = () => {
        if (path.length === 1) {
            return "/";
        } else {
            return "/" + path.slice(0, path.length - 1).join("/") + "/";
        }
    };
    if (props.searchPath) {
        return (
                <div>
                    <ul className="unstyled-list breadcrumbs">
                        {renderBreadcrumbItemsForDesktop()}
                    </ul>
                    <NavLink
                            to={{
                                pathname: getPreviousRouteForMobile(),
                                search: props.searchPath
                            }}
                            className="breadcrumb-mobile">
                        Back to Previous
                    </NavLink>
                </div>
        )
    } else {
        return (
                <div>
                    <ul className="unstyled-list breadcrumbs">
                        {renderBreadcrumbItemsForDesktop()}
                    </ul>
                    <NavLink to={getPreviousRouteForMobile()} className="breadcrumb-mobile">
                        Back to Previous
                    </NavLink>
                </div>
        )
    }
};

export default withRouter(breadcrumbs);

breadcrumbs.propTypes = {
    pageTitle: PropTypes.string,
    searchPath: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/Breadcrumbs/Breadcrumbs.js